module.exports = __webpack_public_path__ + "static/media/undraw_chat_re_re1u.50c77c6e.svg";